'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TetherToggle = exports.DELAY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _tethered = require('ui/tethered');

var _tethered2 = _interopRequireDefault(_tethered);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = _react2['default'].Component,
    PropTypes = _react2['default'].PropTypes;
var DELAY = exports.DELAY = 100;

/**
 * This component takes the same props as the `Tethered` component, but toggles
 * the content when the `anchor` is interacted with.
 */

var TetherToggle = exports.TetherToggle = function (_Component) {
    _inherits(TetherToggle, _Component);

    function TetherToggle(props) {
        _classCallCheck(this, TetherToggle);

        var _this = _possibleConstructorReturn(this, (TetherToggle.__proto__ || Object.getPrototypeOf(TetherToggle)).call(this, props));

        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);

        _this.state = {
            active: false
        };
        return _this;
    }

    /**
     * We wrap the mouse events in a short timer to prevent sudden closures of
     * the menu if the user moves outside of the component.  This can
     * happen if there's some space between the anchor and the menu itself.
     */


    _createClass(TetherToggle, [{
        key: 'handleMouseEnter',
        value: function handleMouseEnter() {
            var _this2 = this;

            clearTimeout(this.timeout);

            this.timeout = setTimeout(function () {
                _this2.setState({ active: true });
            }, DELAY);
        }
    }, {
        key: 'handleMouseLeave',
        value: function handleMouseLeave() {
            var _this3 = this;

            clearTimeout(this.timeout);

            this.timeout = setTimeout(function () {
                _this3.setState({ active: false });
            }, DELAY);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.timeout);
        }
    }, {
        key: 'render',
        value: function render() {
            var active = this.state.active;

            var _props = this.props,
                anchor = _props.anchor,
                children = _props.children,
                disabled = _props.disabled,
                rest = _objectWithoutProperties(_props, ['anchor', 'children', 'disabled']);

            return _react2['default'].createElement(
                'div',
                {
                    onMouseEnter: !disabled && this.handleMouseEnter,
                    onMouseLeave: !disabled && this.handleMouseLeave
                },
                _react2['default'].createElement(
                    _tethered2['default'],
                    _extends({
                        active: active,
                        anchor: anchor
                    }, rest),
                    children
                )
            );
        }
    }]);

    return TetherToggle;
}(Component);

TetherToggle.propTypes = {
    anchor: PropTypes.node.isRequired,
    children: PropTypes.any,
    disabled: PropTypes.bool
};

exports['default'] = TetherToggle;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/tether-toggle/tether-toggle.jsx
 ** module id = 774
 ** module chunks = 0 1
 **/